import httpStore from "@/api/httpStore.js";
import { getPriceLevels } from "@/api/store/CustomersService";

export function getReportsOptions() {
  return [
    {
      label: "Average shipping price",
      value: "average_shipping_price"
    },
    {
      label: "Titles",
      value: "titles",
      enabled: true,
      description: "All titles from db",
      otherOptions: [
        {
          label: "Include products without stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Ebay (price & stock)",
      value: "ebay",
      enabled: true,
      description:
        "This will generate a file with the current stock, price or both to be uploaded to ebay, the report should be uploaded to: https://www.ebay.com/sh/reports/uploads",
      otherOptions: [
        {
          label: "Report type",
          inputType: "select",
          inputId: "type_of_report",
          options: [
            {
              label: "Stock and Price",
              value: "stock_price"
            },
            {
              label: "Stock",
              value: "stock"
            },
            {
              label: "Price",
              value: "price"
            }
          ]
        }
      ]
    },
    {
      label: "Amazon listed products",
      value: "amazon_listed_products",
      description:
        "This will generate a file with the products listed in amazon, including title and aisin"
    },
    {
      label: "Amazon (price & stock)",
      value: "amazon",
      enabled: true,
      description:
        "This will generate a report to be uploaded to amazon: https://sellercentral.amazon.com/listing/upload?ref_=xx_upload_tnav_status, The price comes from the online price plus part_info_local.average_shipping_price. ($9 if not set)",
      otherOptions: [
        {
          label: "Report type",
          inputType: "select",
          inputId: "type_of_report",
          options: [
            {
              label: "Stock and Price",
              value: "stock_price"
            },
            {
              label: "Stock",
              value: "stock"
            },
            {
              label: "Price",
              value: "price"
            }
          ]
        },
        {
          label: "Include FBA",
          inputType: "select",
          inputId: "include_fba",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Shipstation locations",
      value: "shipstation_locations",
      enabled: true,
      description: "locations file to update shipstation inventory"
    },
    {
      label: "Shipstation products",
      value: "shipstation_products_report",
      enabled: true,
      description: "locations file to update shipstation products"
    },
    {
      label: "No weight or dimensions products",
      value: "no_weight_or_dimensions",
      enabled: true,
      description:
        "This will generate a file with the products that does not have weight or dimensions on the database",
      otherOptions: [
        {
          label: "Include products without stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "No Picture products",
      value: "no_picture_products",
      enabled: true,
      description:
        "This will generate a file with the products that does not have picture",
      otherOptions: [
        {
          label: "Include products without stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Warehouse",
          inputType: "select",
          inputId: "warehouse",
          options: []
        }
      ]
    },
    {
      label: "Fastlane products",
      value: "fastlane_products",
      enabled: true,
      description:
        "This will generate a file with the products that are in fastlane, M dependency products only",
      otherOptions: [
        {
          label: "Include products without stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Products not in amazon",
      value: "not_published_to_amazon",
      enabled: true,
      description: "Products not published to Amazon",
      otherOptions: [
        {
          label: "Include products without stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Products not in Walmart",
      value: "not_published_to_walmart",
      enabled: true,
      description: "Products not published to Walmart",
      otherOptions: [
        {
          label: "Include products without stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Products not in ebay",
      value: "not_published_to_ebay",
      enabled: true,
      description: "Products not published to eBay",
      otherOptions: [
        {
          label: "Include products without stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Listings creator bulk file (AMAZON - EBAY)",
      value: "listings_creation_file",
      enabled: true,
      description: "Generate file to create listings in marketplace",
      otherOptions: [
        {
          label: "Marketplace",
          inputType: "select",
          inputId: "marketplace",
          options: [
            {
              label: "Amazon",
              value: "amazon"
            },
            {
              label: "Ebay",
              value: "ebay"
            }
          ]
        },
        {
          label: "Export not listed only",
          inputType: "select",
          inputId: "not_listed_only",
          options: [
            {
              label: "Yes - unlisted only",
              value: "yes"
            },
            {
              label: "No - export all",
              value: "no"
            }
          ]
        },
        {
          label: "Include products without stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Max items to export",
          inputType: "text",
          inputId: "max_items_to_export"
        }
      ]
    },
    {
      label: "Listings update bulk file (AMAZON - EBAY)",
      value: "listings_update_file",
      enabled: true,
      description: "Generate file to update existing listings in marketplace",
      otherOptions: [
        {
          label: "Marketplace",
          inputType: "select",
          inputId: "marketplace",
          options: [
            {
              label: "Amazon",
              value: "amazon"
            },
            {
              label: "Ebay",
              value: "ebay"
            }
          ]
        },
        {
          label: "Include titles",
          inputType: "select",
          inputId: "include_titles",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Include description",
          inputType: "select",
          inputId: "include_description",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Include store category",
          inputType: "select",
          inputId: "include_store_category",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Include ebay category",
          inputType: "select",
          inputId: "include_ebay_category",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Include weight",
          inputType: "select",
          inputId: "include_weight",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Include dimensions",
          inputType: "select",
          inputId: "include_dimensions",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Include images",
          inputType: "select",
          inputId: "include_images",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "include Shipping ProfileName",
          inputType: "select",
          inputId: "include_shipping_profile_name",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Max items to export (empty for all)",
          inputType: "text",
          inputId: "max_items_to_export"
        }
      ]
    },
    {
      label: "Export products by category",
      value: "products_by_category",
      enabled: true,
      description: `export all products on that category`,
      otherOptions: [
        {
          label: "category",
          inputType: "multiselect",
          inputId: "category_url",
          options: []
        },
        {
          label: "subcategory",
          inputType: "multiselect",
          inputId: "sub_category_url",
          required: true,
          dependsOn: "category_url",
          options: []
        },
        {
          label: "Include products without stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "display stock",
          inputType: "select",
          inputId: "display_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "display price",
          inputType: "select",
          inputId: "display_price",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "display line",
          inputType: "select",
          inputId: "display_line",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "price level",
          inputType: "select",
          inputId: "price_level",
          options: getPriceLevels()
        },
        {
          label: "display unificado",
          inputType: "select",
          inputId: "display_unificado",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Description type",
          inputType: "select",
          inputId: "description_type",
          options: [
            {
              label: "Regular",
              value: "regular"
            },
            {
              label: "Alternative description",
              value: "alternative_description"
            }
          ]
        },
        {
          label: "Department",
          inputType: "select",
          inputId: "department",
          options: []
        },
        {
          label: "warehouse",
          inputType: "select",
          inputId: "warehouse",
          options: []
        }
      ]
    },
    {
      label: "Amazon categories",
      value: "amazon_categories",
      enabled: true,
      description: `export all products with the amazon category for listing`,
      otherOptions: [
        {
          label: "Include products without stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Products Sold without stock",
      value: "sold_without_stock",
      enabled: true,
      description: `All products sold in a time range without stock now`,
      otherOptions: [
        {
          label: "days from toda",
          inputType: "select",
          inputId: "days",
          options: [
            {
              label: "90",
              value: "90"
            },
            {
              label: "60",
              value: "60"
            },
            {
              label: "30",
              value: "30"
            }
          ]
        }
      ]
    },
    {
      label: "NKR Departamentos - lista de precios",
      value: "nkr_multidep_price_list",
      enabled: true,
      otherOptions: [
        {
          label: "Marca",
          inputType: "multiselect",
          inputId: "brand"
        },
        {
          label: 'Marca vehiculo ("All" for all)',
          inputType: "multiselect",
          inputId: "vehicle_brand"
        },
        {
          label: "Categoria (para filtrar subcategorias)",
          inputType: "select",
          inputId: "category",
          serverField: false
        },
        {
          label: "Subcategoria",
          inputType: "multiselect",
          inputId: "subcategory",
          dependsOn: "category"
        },
        {
          label: "price level",
          inputType: "select",
          inputId: "price_level",
          options: getPriceLevels()
        },
        {
          label: "Dependencia",
          inputType: "multiselect",
          inputId: "dependencia"
        },
        {
          label: "Product price group",
          inputType: "multiselect",
          inputId: "product_price_group"
        },
        {
          label: "Incluir productos sin stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "No",
              value: "no"
            },
            {
              label: "Yes",
              value: "yes"
            }
          ]
        },
        {
          label: "display unificado",
          inputType: "select",
          inputId: "display_unificado",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        },
        {
          label: "Description type",
          inputType: "select",
          inputId: "description_type",
          options: [
            {
              label: "Regular",
              value: "regular"
            },
            {
              label: "Alternative description",
              value: "alternative_description"
            }
          ]
        }
      ]
    },
    {
      label: "Vehicles with family assignment",
      value: "vehicles_family_export",
      enabled: true,
      description:
        "Export all vehicles with their family assignment (catalog_code). Use this to review and update family assignments via bulk upload."
    },
    {
      label: "POLIMOTOR - Lista de precios Polimotor",
      value: "polimotor_price_list",
      enabled: true,
      otherOptions: [
        {
          label: "Marca",
          inputType: "multiselect",
          inputId: "brand"
        },
        {
          label: 'Marca vehiculo ("All" for all)',
          inputType: "multiselect",
          inputId: "vehicle_brand"
        },
        {
          label: "Show unificado",
          inputType: "select",
          inputId: "show_unificado",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "Inventario para conteo fisico",
      value: "inventory_count",
      enabled: true,
      description:
        "Genera una lista de productos con su ubicacion en bodega y una columna vacia para anotar el conteo fisico manual. Ordenado por ubicacion para recorrer la bodega de forma secuencial.",
      otherOptions: [
        {
          label: "Marca",
          inputType: "multiselect",
          inputId: "brand"
        },
        {
          label: 'Marca vehiculo ("All" for all)',
          inputType: "multiselect",
          inputId: "vehicle_brand"
        },
        {
          label: "Incluir productos sin stock",
          inputType: "select",
          inputId: "include_no_stock",
          options: [
            {
              label: "No",
              value: "no"
            },
            {
              label: "Yes",
              value: "yes"
            }
          ]
        },
        {
          label: "Mostrar stock actual del sistema",
          inputType: "select",
          inputId: "show_system_stock",
          options: [
            {
              label: "Yes",
              value: "yes"
            },
            {
              label: "No",
              value: "no"
            }
          ]
        }
      ]
    },
    {
      label: "POLIMOTOR - Revision de stock en base a ventas",
      value: "polimotor_sold_items",
      enabled: true,
      description:
        "This report will show the products that were sold in a date range but currently do not have stock, this is useful to identify if there are products that should be restocked or if there are stock issues. The date range is based on the order date, not the shipping date.",
      otherOptions: [
        {
          label: "From date",
          inputType: "date",
          inputId: "from_date"
        },
        {
          label: "To date",
          inputType: "date",
          inputId: "to_date"
        }
      ]
    }
  ];
}

export function getReportFileInfo(reportId) {
  return httpStore.get(`/reports/info/${reportId}`).then(res => res.data);
}

export function pollReportUntilDone(reportId, onTick, intervalMs = 3000) {
  return new Promise((resolve, reject) => {
    const timer = setInterval(async () => {
      try {
        const info = await getReportFileInfo(reportId);
        if (onTick) onTick(info);
        if (info.status !== "in_process") {
          clearInterval(timer);
          resolve(info);
        }
      } catch (e) {
        // keep polling on transient errors
      }
    }, intervalMs);
    // expose cancel handle via reject path stored on the promise
    resolve._cancel = () => {
      clearInterval(timer);
      reject(new Error("cancelled"));
    };
  });
}

export function requestReport(requestInfo) {
  return httpStore
    .post("/reports/request", { requestInfo })
    .then(res => res.data);
}

export async function signAndDownloadFile(fileKey, s3Url = null) {
  const signedRoute = await httpStore
    .get(`upload/sign?filename=${fileKey}&s3url=${s3Url}`)
    .then(res => res.data)
    .catch(() => {
      return false;
    });
  console.log("signedRoute", signedRoute);
  if (!signedRoute || !signedRoute.url) {
    return false;
  }
  console.log(signedRoute);
  window.open(signedRoute.url, "_blank");
  return true;
}

export function getReports() {
  return httpStore.get(`/reports`).then(res => res.data);
}
